import { createRoot } from "@wordpress/element";
import { useState, useEffect } from "@wordpress/element";

import DesktopMenu from "./component/desktopMenu";
import MobileMenu from "./component/mobileMenu.js";
import useWindowSize from "./component/useWindowSize";

/**
 * MegaMenu Component
 */
const MegaMenu = ({ base_url, lang, menus }) => {
	const { width, height } = useWindowSize({ useState, useEffect });
	// const url = `${base_url}/wp-json/header/v1/menus/`;
	// const index_payload = { lang, menu: "index-menu" };
	// const fast_payload = { lang, menu: "fast-menu" };
	// const lang_payload = { lang, menu: "lang-menu" };
	// const index_menu = useFetchData(url, index_payload, useQuery);
	// const fast_menu = useFetchData(url, fast_payload, useQuery);
	// const lang_menu = useFetchData(url, lang_payload, useQuery);

	const index_menu = menus["index_menu"];
	const fast_menu = menus["fast_menu"];
	const lang_menu = menus["lang_menu"];

	const [activeIndex, setActiveIndex] = useState(null);

	const handleMouseEnter = (index) => {
		setActiveIndex(index);
	};

	const handleMouseLeave = () => {
		setActiveIndex(null);
	};

	const variants = {
		hidden: { opacity: 0, y: -20 },
		visible: { opacity: 1, y: 0, transition: { duration: 0.3 } },
	};

	return (
		<>
			{width > 1100 ? (
				<DesktopMenu
					index_menu={index_menu}
					fast_menu={fast_menu}
					lang_menu={lang_menu}
					lang={lang}
				/>
			) : (
				<MobileMenu
					index_menu={index_menu}
					fast_menu={fast_menu}
					lang_menu={lang_menu}
					lang={lang}
				/>
			)}
		</>
	);
};

document.addEventListener("DOMContentLoaded", () => {
	const blocks = document.querySelectorAll(".menu-data");

	blocks.forEach((block) => {
		const lang = block.getAttribute("data-lang");
		const base_url = block.getAttribute("base-url");
		const menu_data = block.getAttribute("data-menu");
		const obj = JSON.parse(menu_data);
		const root = createRoot(block);
		root.render(<MegaMenu base_url={base_url} lang={lang} menus={obj} />);
	});
});
